import React from 'react';

/**
 * Inline SVG of the Ethiopian flag.
 *
 * Why not the 🇪🇹 emoji: regional-indicator flag emojis don't render on
 * many Linux/Windows builds and some Telegram clients — they fall back
 * to literal "ET" letters. SVG renders identically everywhere, including
 * inside Telegram WebView and on cheap Android devices.
 */
interface Props {
  /** Width in px. Height auto-calculated to preserve 3:2 ratio. */
  size?: number;
  /** Inline style override (margin, etc.). */
  style?: React.CSSProperties;
  /** Aria label, defaults to "Ethiopian flag". */
  ariaLabel?: string;
}

const EthiopianFlag: React.FC<Props> = ({
  size = 16,
  style,
  ariaLabel = 'Ethiopian flag',
}) => {
  const h = Math.round((size * 2) / 3); // 3:2 ratio
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 30 20"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel}
      style={{ display: 'inline-block', verticalAlign: '-2px', borderRadius: 2, ...style }}
    >
      <rect width="30" height="6.67" fill="#078930" />
      <rect y="6.67" width="30" height="6.67" fill="#FCDD09" />
      <rect y="13.33" width="30" height="6.67" fill="#DA121A" />
      <circle cx="15" cy="10" r="4.5" fill="#0F47AF" />
      {/* 5-pointed star, simplified geometry */}
      <polygon
        points="15,7.2 15.7,9.2 17.85,9.2 16.1,10.45 16.78,12.5 15,11.25 13.22,12.5 13.9,10.45 12.15,9.2 14.3,9.2"
        fill="#FCDD09"
      />
    </svg>
  );
};

export default EthiopianFlag;
